import CustomTabPane, { TabProps } from "@/components/TabPane";
import { InspectionOrderItem } from "@/types/inspection";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import ItemList from "../InspectionDetail/ItemList";
import SDoc from "@/components/SDoc";
import { itemUpdate } from "@/apis/inspection";
import { getLocationIdx } from "@/utils/wLocation";

const InpectionItemHome: FC = () => {
  const { t } = useTranslation();


  const handleItemDoc = (info: InspectionOrderItem, docId: string) => {
    itemUpdate(info.id, { docId });
  };

  const openTab: (info: InspectionOrderItem) => { ["doc"]: TabProps } = useCallback((info) => {
    return {
      doc: {
        key: "doc",
        label: `${getLocationIdx(info?.itemLocation?.location)}-${t('inspection.attechment')}`,
        children: <SDoc docId={info?.docId || undefined} handleNewDocId={(docId) => handleItemDoc(info, docId)} />
      },
    }
  }, [handleItemDoc]);
  return (
    <CustomTabPane<InspectionOrderItem> defaultKey={"item"} defaultTabs={[
      {
        key: "item",
        label: t("inspection.inspectItem"),
        children: <ItemList />,
        closable: false,
      },
    ]} onOpens={(info) => openTab(info)} />
  )
};

export default InpectionItemHome;